import { LatLngLiteral } from "leaflet";
import { EXPOSURE_COLORS, RATING_COLORS } from "./bands";

export const MARKER_PANE_LAYER_NAME = "circles-pane";

/**
 * Point count above which PointsDisplay switches from rendering every marker
 * to viewport-based clustering. Rendering each point as its own Leaflet layer
 * crashes the browser well before 5k points, and clustering keeps the mounted
 * marker count bounded regardless of collection size.
 */
export const CLUSTERING_POINT_THRESHOLD = 250;

export const SIDEBAR_WIDTH = {
  DEFAULT: 55,
  MIN: 35,
  MAX: 65,
} as const;

/**
 * Map animation durations (in seconds)
 */
export const MAP_ANIMATION_DURATION = {
  CLICK: 0.4,
} as const;

/**
 * Marker styling parameters
 */
export const MARKER_STYLE = {
  SELECTED: { strokeWidth: 4, radius: 12, opacity: 1, strokeColor: "black" },
  HIGHLIGHTED: { strokeWidth: 3, radius: 12, opacity: 1, strokeColor: "black" },
  HOVERED: { strokeWidth: 2, radius: 12, opacity: 1, strokeColor: "black" },
  DIMMED: { strokeWidth: 1, radius: 7, opacity: 0.3, strokeColor: "#333333" },
  DEFAULT: { strokeWidth: 1, radius: 7, opacity: 1, strokeColor: "#333333" },
} as const;

/** Both defined next to the band identity they describe; re-exported for callers. */
export { EXPOSURE_COLORS, RATING_COLORS };

/**
 * Determines marker style based on point state
 */
export const getMarkerStyle = (params: {
  isSelected: boolean;
  isHighlighted: boolean;
  isHovered?: boolean;
  isDimmed: boolean;
}) => {
  if (params.isSelected) return MARKER_STYLE.SELECTED;
  if (params.isHighlighted) return MARKER_STYLE.HIGHLIGHTED;
  if (params.isHovered) return MARKER_STYLE.HOVERED;
  if (params.isDimmed) return MARKER_STYLE.DIMMED;

  return MARKER_STYLE.DEFAULT;
};

/**
 * Popup dimensions for point details
 */
export const POPUP_WIDTH_PX = {
  ABC: 250,
  HALO: 480,
} as const;

export const getSatelliteImageUrl = ({ lat, lng }: LatLngLiteral) => {
  return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=18&scale=2&size=600x400&maptype=satellite&format=png&key=${process.env.NEXT_PUBLIC_GOOGLE_API_KEY}&markers=size:mid|color:red|label:1|${lat},${lng}`;
};
